export default "__VITE_ASSET__BwChkgve__"